import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=73331a4a&scoped=true&"
import script from "./Donation.vue?vue&type=script&lang=js&"
export * from "./Donation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73331a4a",
  null
  
)

export default component.exports